import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const GraduationDay2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GraduationDay2025/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GraduationDay2025/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GraduationDay2025/3.webp`;
     

1
   
const photos = [
  {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                               Graduation Day
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Date: 31 January 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                National Public School, Yeshwanthpur celebrated its Graduation Day on 31 January 2026 in an
atmosphere filled with pride, joy and heartfelt celebration. The occasion honoured the Class
of 2025–26, marking a significant milestone in their academic journey. A total of 72
graduating students made a dignified entry, clad in their ceremonial gowns and caps—
symbolising the successful completion of their school years and the dawn of new beginnings.
                                <br></br>
                                The programme opened on an auspicious note with the lighting of the ceremonial lamp by
the distinguished guests, followed by a graceful invocation dance that infused the occasion
with a sense of reverence and joy. The highlight of the ceremony was the Convocation
Address delivered by Mr Kurma Rao M, IAS Chief Executive Officer and Secretary Coffee
Board, Bengaluru Government of India. In his address, he encouraged the graduates to
embrace the thought, “You are unique. Discover your purpose and enjoy the process.”
                                <br></br>
                                Addressing the gathering, Principal Ms Sheeja Manoj encouraged the students to go forth
with courage and walk their chosen path with humility and purpose, urging them to make
their mark on the world and contribute towards making it a kinder, wiser and more just place
to coexist. Principal Ma’am then formally conferred graduation upon the students, a moment
met with resounding applause, symbolising the close of one chapter and the commencement
of another.
                               <br></br>
                                A blend of emotion and light-heartedness followed as individual student profiles were read
aloud, capturing their dreams, accomplishments and memorable moments. Heartfelt
reflections shared by students and parents added depth to the celebration, as they spoke
about personal challenges, transformative experiences and growth during their years at the
school.
                              <br></br>
                               The event culminated in the final retreat of the graduates, who carried the symbolic lamp of
knowledge and the enduring legacy of their alma mater. This poignant moment filled the
auditorium with pride, marking their transition from school students to confident graduates
ready to step into the world beyond.
                               <br></br>
                               The celebrations concluded with a festive dinner, where students, parents and faculty came
together to reminisce and celebrate the day’s significance. The air was filled with joy and
nostalgia as the Class of 2025 shared one final bonding moment with their teachers and peers
before moving forward into the future. The day stood as a memorable tribute to
achievement, inspiration, and new beginnings.
                               <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Have the courage to follow your heart and intuition—they already know who you want to become!”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GraduationDay2025;